export * from './TeamSection'
export * from './PageSection'
export * from './AboutUs'
export * from './CallToAction'
export * from './Footer'
export * from './Hero'
export * from './Navbar'
export * from './Investors'
export * from './Academy'
export * from './Recognitions'
export * from './Video'
export * from './SocialBar'